// extracted by mini-css-extract-plugin
module.exports = {"tableDiff":"table-diff_tableDiff__QqAIA"};